import {
  Box,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import AppBarResourceList from "../../components/AppBar/ResourceList";
import ReportInvoiceWeekSummary from "../../components/Report/InvoiceWeekSummary";
import { getAllData } from "../../libs/firebase/firestore/getAllData";
import { getClients } from "../../libs/toggl/getClients";
import { getProjects } from "../../libs/toggl/getProjects";
import { getTags } from "../../libs/toggl/getTags";
import { getWeeklyTimeEntries } from "../../libs/toggl/getWeeklyTimeEntires";
import { mailTo } from "../../utilities/mailTo";

export default function ScreenReportingRoot() {
  // state for projects
  const [projects, setProjects] = React.useState([]);

  // state for clients
  const [clients, setClients] = React.useState([]);

  // state for resource lists
  const [resourceLists, setResourceLists] = React.useState([]);

  // loading state
  const [loading, setLoading] = React.useState(true);

  // state for tags
  const [tags, setTags] = React.useState([]);

  useEffect(() => {
    // get the projects from firebase
    getProjects(
      (data) => {
        setProjects(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
    getClients(
      (data) => {
        setClients(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
    getTags(
      (data) => {
        setTags(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );

    getAllData(
      "resourceLists",
      (data) => {
        setResourceLists(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  // console.log(resourceLists);

  const handleOnDownloadInvoice = () => {
    window.location.href = mailTo(
      "elisabeth@gardensavvy.ca",
      "Invoice",
      "Hey Elisabeth,\n\n here is the invoice for last week. Hope you are doing well!"
    );
  };

  const handleInvoiced = () => {
    getWeeklyTimeEntries((data) => {
      // setTimeEntries(data);
      setLoading(false);
    });
  };

  let thisWeekMonday = new Date();
  thisWeekMonday.setDate(
    thisWeekMonday.getDate() - thisWeekMonday.getDay() + 1
  );

  // 1 week ago monday
  let lastWeekMonday = new Date();
  lastWeekMonday.setDate(
    lastWeekMonday.getDate() - lastWeekMonday.getDay() - 6
  );

  // 2 weeks ago monday
  let twoWeeksAgoMonday = new Date();
  twoWeeksAgoMonday.setDate(
    twoWeeksAgoMonday.getDate() - twoWeeksAgoMonday.getDay() - 13
  );

  // 3 weeks ago monday
  let threeWeeksAgoMonday = new Date();
  threeWeeksAgoMonday.setDate(
    threeWeeksAgoMonday.getDate() - threeWeeksAgoMonday.getDay() - 19
  );

  return (
    <Box>
      <AppBarResourceList />
      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Reporting</Typography>
        <Typography variant="subtitle1">
          Here is the reporting information for last week
        </Typography>

        <Divider
          sx={{
            my: 2,
          }}
        />
        {/* loader */}
        {(!clients || !projects || !tags) && (
          <Box
            style={{
              textAlign: "center",
              margin: "2rem 0rem",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <Stack spacing={2}>
          <ReportInvoiceWeekSummary
            title={"This week"}
            projects={projects}
            clients={clients}
            tags={tags}
            mondayDate={thisWeekMonday}
          />
          <ReportInvoiceWeekSummary
            title={"Last week"}
            projects={projects}
            clients={clients}
            tags={tags}
            mondayDate={lastWeekMonday}
          />
          <ReportInvoiceWeekSummary
            title={"2 weeks ago"}
            projects={projects}
            clients={clients}
            tags={tags}
            mondayDate={twoWeeksAgoMonday}
          />
          <ReportInvoiceWeekSummary
            title={"3 weeks ago"}
            projects={projects}
            clients={clients}
            tags={tags}
            mondayDate={threeWeeksAgoMonday}
          />
        </Stack>
      </Box>
    </Box>
  );
}
